import { useReducedMotion } from 'motion/react';
import { useEffect, useState } from 'react';

/**
 * How many of a slide's timed steps already happened: step `i` happens
 * `atMs[i]` ms after the slide enters. All of them at once under reduced
 * motion (NEWS-09: the final state); leaving the slide cancels the rest.
 * `atMs` must be stable (a module constant).
 */
export function useSteps(atMs: readonly number[]): number {
  const reduceMotion = useReducedMotion() ?? false;
  const [count, setCount] = useState(reduceMotion ? atMs.length : 0);

  useEffect(() => {
    if (reduceMotion) {
      setCount(atMs.length);
      return;
    }
    setCount(0);
    const timers = atMs.map((ms, i) =>
      setTimeout(() => setCount((current) => Math.max(current, i + 1)), ms)
    );
    return () => timers.forEach(clearTimeout);
  }, [atMs, reduceMotion]);

  return count;
}
